module.exports = __webpack_public_path__ + "img/manulife-men-on-laptop.e706364b.png";